import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmPasswordReset } from "../features/auth/authThunks.js";
import { clearPasswordResetState } from "../features/auth/authSlice.js";

import "../styles/password/reset-password.css";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    passwordResetLoading,
    passwordResetError,
    passwordResetSuccessMessage,
  } = useSelector((state) => state.auth);

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return (params.get("token") || "").trim();
  }, [location.search]);

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  useEffect(() => {
    dispatch(clearPasswordResetState());
  }, [dispatch]);

  const passwordsMatch = password && password2 && password === password2;
  const showMismatch = password2 && !passwordsMatch;

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(clearPasswordResetState());

    if (!passwordsMatch) return;

    await dispatch(confirmPasswordReset({ token, password }));
  };

  const shouldShowForm = token && !passwordResetSuccessMessage;

  return (
    <div className="rp-page">
      <div className="rp-card">
        <div className="rp-header">
          <h1 className="rp-title">Restablecer contraseña</h1>
          <p className="rp-subtitle">
            Crea una nueva contraseña para tu cuenta.
          </p>
        </div>

        {!token && (
          <div className="rp-message rp-message--error">
            Falta el token. Abre el enlace del email.
          </div>
        )}

        {shouldShowForm && (
          <form className="rp-form" onSubmit={handleSubmit}>
            <div className="rp-field">
              <label htmlFor="password">Nueva contraseña</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
                className="rp-input"
                autoComplete="new-password"
              />
            </div>

            <div className="rp-field">
              <label htmlFor="password2">Repite la contraseña</label>
              <input
                id="password2"
                type="password"
                value={password2}
                onChange={(event) => setPassword2(event.target.value)}
                required
                className={`rp-input ${showMismatch ? "rp-input--error" : ""}`}
                autoComplete="new-password"
              />

              {showMismatch && (
                <div className="rp-inline-error">
                  Las contraseñas no coinciden.
                </div>
              )}
            </div>

            <div className="rp-actions">
              <button
                type="submit"
                disabled={passwordResetLoading || !passwordsMatch}
                className="rp-btn rp-btn--primary"
              >
                {passwordResetLoading ? "Guardando…" : "Guardar nueva contraseña"}
              </button>

              <button
                type="button"
                className="rp-btn rp-btn--ghost"
                onClick={() => navigate("/log-in")}
                disabled={passwordResetLoading}
              >
                Volver al login
              </button>
            </div>
          </form>
        )}

        {passwordResetSuccessMessage && (
          <div className="rp-message rp-message--success">
            {passwordResetSuccessMessage}
            <div className="rp-success-actions">
              <button
                type="button"
                className="rp-btn rp-btn--primary"
                onClick={() => navigate("/log-in")}
              >
                Ir a iniciar sesión
              </button>
            </div>
          </div>
        )}

        {passwordResetError && (
          <div className="rp-message rp-message--error">{passwordResetError}</div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;